import { Components, PaletteMode, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';

export const MuiBreadcrumbsTheme = (mode: PaletteMode): Components<Theme>['MuiBreadcrumbs'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      ol: {
        flexWrap: 'nowrap',
      },
      li: {
        '& a': {
          fontWeight: typographyTokens.fontWeights.semibold,
          border: 'none',
        },
        // Target the last/active breadcrumb link
        '& a[aria-current="page"]': {
          color: componentTokens.breadcrumbs.colors.primary.text.selected,
          '&:hover': {
            color: componentTokens.breadcrumbs.colors.primary.text.hover,
          },
        },
      },
    },
  };
};
